import { GET_RETURN_ORDERS, ADD_RETURN_ORDER } from 'redux/actionTypes';

export default function returnOrders(state = [], action) {
    switch(action.type) {
        case GET_RETURN_ORDERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_RETURN_ORDER:
            return [
                action.payload,
                ...state
            ];
        default:
            return state;
    }
};